import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface Chapter {
  number: number;
  title: string;
  description: string;
}
interface Part {
  number: number;
  title: string;
  chapters: Chapter[];
}
export function Contents() {
  const [openPart, setOpenPart] = useState<number | null>(1);
  const parts: Part[] = [{
    number: 1,
    title: 'El juego que debes conocer',
    chapters: [{
      number: 1,
      title: '¿Por qué el padel no es solo fuerza?',
      description: 'slide con split: foto izq + estadísticas táctica der'
    }, {
      number: 2,
      title: 'La cancha como aliada: paredes, ángulos y zonas',
      description: 'diagrama de cancha cenital con zonas coloreadas'
    }, {
      number: 3,
      title: 'Cómo se estructura un punto en padel moderno',
      description: 'flujograma horizontal: Saque → Red → Pared → Definición'
    }]
  }, {
    number: 2,
    title: 'Técnica aplicada al juego real',
    chapters: [{
      number: 4,
      title: 'La volea',
      description: 'foto + diagrama de ángulos de volea'
    }, {
      number: 5,
      title: 'El globo',
      description: 'secuencia de 3 fotos + arco de trayectoria sobre cancha'
    }, {
      number: 6,
      title: 'Bandeja y smash',
      description: 'comparativa visual lado a lado'
    }, {
      number: 7,
      title: 'La bajada de pared',
      description: 'storyboard 4 pasos + QR a video'
    }, {
      number: 8,
      title: 'El servicio',
      description: 'diagrama de targets por tipo de rival'
    }]
  }, {
    number: 3,
    title: 'Tácticas de pareja',
    chapters: [{
      number: 9,
      title: 'Los 4 sistemas de juego',
      description: '4 diagramas de cancha en grilla 2x2'
    }, {
      number: 10,
      title: 'Posicionamiento',
      description: 'before/after: posición incorrecta vs correcta'
    }, {
      number: 11,
      title: 'Comunicación',
      description: 'iconografía de señas, fondo verde oscuro'
    }, {
      number: 12,
      title: 'Dominar la red',
      description: 'diagrama animado de cobertura'
    }]
  }, {
    number: 4,
    title: 'Lectura del juego',
    chapters: [{
      number: 13,
      title: 'Perfiles de rival',
      description: '3 tarjetas: defensivo / agresivo / lobero con íconos'
    }, {
      number: 14,
      title: 'Momentos clave',
      description: 'línea de tiempo visual del set'
    }, {
      number: 15,
      title: 'Factores ambientales',
      description: 'diagrama cancha + íconos de viento/sol/calor'
    }, {
      number: 16,
      title: 'El tercer set',
      description: 'infografía mental, paleta tranquila'
    }]
  }, {
    number: 5,
    title: 'Entrenamiento inteligente',
    chapters: [{
      number: 17,
      title: 'Plan semanal',
      description: 'tabla visual días de la semana con bloques de color'
    }, {
      number: 18,
      title: 'Ejercicios de pista',
      description: '6 diagramas de drills, grilla 2x3'
    }, {
      number: 19,
      title: 'Físico para el padel',
      description: '3 pilares en iconografía circular'
    }]
  }, {
    number: 6,
    title: 'Partidos reales, decisiones reales',
    chapters: [{
      number: 20,
      title: 'Análisis de 3 puntos',
      description: 'cancha con flechas: decisión tomada vs ideal'
    }, {
      number: 21,
      title: 'Plan de partido',
      description: 'plantilla descargable con campos editables'
    }, {
      number: 22,
      title: 'Checklist del jugador',
      description: 'diseño tipo carnet, check visual'
    }]
  }];
  return <section className="w-full bg-black py-16 px-4" data-id="element-33">
      <div className="max-w-5xl mx-auto" data-id="element-34">
        <h2 className="headline-font text-4xl md:text-5xl text-center text-white uppercase mb-4" data-id="element-35">
          ¿Qué Incluye{' '}
          <span className="text-[#C6FF3C]" data-id="element-36">Padel Smart Pro Elite</span>?
        </h2>
        <p className="text-center text-gray-400 text-lg mb-12" data-id="element-37">
          22 capítulos organizados en 6 partes fundamentales
        </p>

        <div className="space-y-4" data-id="element-38">
          {parts.map(part => <div key={part.number} className="border border-gray-800 rounded-lg overflow-hidden bg-[#0a0a0a]" data-id="element-39">
              <button onClick={() => setOpenPart(openPart === part.number ? null : part.number)} className="w-full flex items-center justify-between p-6 hover:bg-gray-900 transition-colors" data-id="element-40">
                <div className="flex items-center gap-4" data-id="element-41">
                  <span className="bg-[#C6FF3C] text-black font-bold px-4 py-2 rounded text-lg" data-id="element-42">
                    PARTE {part.number}
                  </span>
                  <h3 className="text-xl font-bold text-white text-left" data-id="element-43">
                    {part.title}
                  </h3>
                </div>
                {openPart === part.number ? <ChevronUp className="w-6 h-6 text-[#C6FF3C]" data-id="element-44" /> : <ChevronDown className="w-6 h-6 text-gray-400" data-id="element-45" />}
              </button>

              {openPart === part.number && <div className="px-6 pb-6 space-y-3" data-id="element-46">
                  {part.chapters.map(chapter => <div key={chapter.number} className="flex items-center gap-4 p-4 bg-gray-900/50 rounded-lg border border-gray-800" data-id="element-47">
                      <div className="flex-shrink-0" data-id="element-48">
                        <span className="inline-flex items-center justify-center w-10 h-10 bg-[#C6FF3C]/10 border border-[#C6FF3C] rounded-full text-[#C6FF3C] font-bold" data-id="element-49">
                          {chapter.number}
                        </span>
                      </div>
                      <h4 className="font-bold text-white" data-id="element-50">{chapter.title}</h4>
                    </div>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}